import { render, staticRenderFns } from "./OrsAppBarPhones.vue?vue&type=template&id=108c647c&scoped=true&"
var script = {}
import style0 from "./OrsAppBarPhones.vue?vue&type=style&index=0&id=108c647c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108c647c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/lib/jenkins/workspace/orse-infra-novo-portal-frontend-ecs/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {VIcon})
